<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionAcademyInvitationsDropDownFilters"
  >
    <form
      key="academyInvitationsDropDownFilters"
      autocomplete="off"
      name="InvitationsDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyInvitationsDropDownFilters.input.actor.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.tipo"
                :elements="$filters.parameters.actors"
                key-field="id"
                name="actor"
                reference="actor"
                text-field="name"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyInvitationsDropDownFilters.input.email.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.email"
                class="a-input-primary"
                name="email"
                :placeholder="$t('mEditionAcademyInvitationsDropDownFilters.input.email.placeholder')"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionAcademyInvitationsDropDownFilters.input.fecha.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionAcademyInvitationsDropDownFilters.input.fecha.desde.placeholder')"
              />
              <span class="margin-bottom-xlarge"></span>
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionAcademyInvitationsDropDownFilters.input.fecha.hasta.placeholder')"
              />
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionAcademyInvitationsDropDownFilters.buttons.reload') }}
        </button>
        <button
          class="a-button-primary a-button-academy-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionAcademyInvitationsDropDownFilters.buttons.search') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyInvitationsDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      filter: {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        tipo: ''
      }
    }
  },

  watch: {
    filterSeted: {
      deep: true,

      handler () {
        this.filter.email = this.filterSeted.email
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.tipo = this.filterSeted.tipo
      },

      immediate: true
    }
  },

  methods: {
    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionAcademyInvitationsDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
